<template>
    <div>
        <!-- 정보입력 -->
        <div class="join-row-wrap">
            <!-- 정보입련: 일반 -->
            <div class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">회원정보 필수입력</h3>
                </div>
                <div role="table" class="board-table board-table--input">
                    <div role="rowgroup">
                        <div role="row">
                            <div role="columnheader" class="align-center">아이디</div>
                            <div role="cell">
                                <input class="input w-100" type="text" name="username" v-model="user.username" @input="input" />
                            </div>
                        </div>
                        <div role="row">
                            <div role="columnheader" class="align-center">비밀번호</div>
                            <div role="cell">
                                <input class="input w-100" type="password" name="password" v-model="user.password" @input="input" />
                                <p class="d-block text-grey mt-4 font-size-10 font-size-lg-12">* (영문대소문자/숫자/특수문자 조합, 8 - 16자)</p>
                            </div>
                        </div>
                        <div role="row">
                            <div role="columnheader" class="align-center">비밀번호 확인</div>
                            <div role="cell">
                                <input class="input w-100" type="password" name="password2" v-model="user.passwordConfirm" @input="input" />
                            </div>
                        </div>
                        <div role="row">
                            <div role="columnheader" class="align-center">
                                <span>가입유형</span>
                            </div>
                            <div role="cell">
                                <v-radio-group v-model="user.kind" row hide-details dense class="my-0 py-0" style="display: flex; align-items: center; height:45px;">
                                    <v-radio v-for="kind in kinds" :key="kind.value" :label="kind.text" :value="kind.value" />
                                </v-radio-group>
                            </div>
                        </div>
                        <div role="row">
                            <div role="columnheader" class="align-center">
                                <span>이름</span>
                            </div>
                            <div role="cell">
                                <input class="input w-100" type="text" name="name" v-model="user.name" @input="input" />
                            </div>
                        </div>
                        <div role="row">
                            <div role="columnheader" class="align-center">
                                <span class="my-md-n3">소속/부서<br class="d-none d-md-inline" />(학교/학과)</span>
                            </div>
                            <div role="cell">
                                <input class="input w-100" type="text" name="affiliation" v-model="user.affiliation" @input="input" />
                            </div>
                        </div>
                        <template v-if="!isSupporter">
                            <div role="row">
                                <div role="columnheader" class="align-center">
                                    <span>생년월일</span>
                                </div>
                                <div role="cell">
                                    <input v-model="user.bornAt" type="date" class="input w-100" />
                                </div>
                            </div>
                            <div role="row">
                                <div role="columnheader" class="align-center">
                                    <span>성별</span>
                                </div>
                                <div role="cell">
                                    <v-radio-group v-model="user.gender" row hide-details dense class="my-0 py-0" style="display: flex; align-items: center; height: 45px;">
                                        <v-radio label="남성" value="남성" />
                                        <v-radio label="여성" value="여성" />
                                    </v-radio-group>
                                </div>
                            </div>
                            <div role="row">
                                <div role="columnheader" class="align-center">
                                    <span>지역</span>
                                </div>
                                <div role="cell">
                                    <v-select v-model="user.region" :items="regions" hide-details dense class="select my-0 py-0" />
                                </div>
                            </div>
                            <!-- <div role="row">
                                <div role="columnheader" class="align-center">
                                    <span>주민등록번호</span>
                                </div>
                                <div role="cell">
                                    <div class="form-id-num">
                                        <input class="input w-100" type="text" name="residentNumber1" v-model="user.residentNumber1" @input="input" maxlength="6" />
                                        <span class="text"></span>
                                        <input class="input w-100" type="text" name="residentNumber2" v-model="user.residentNumber2" @input="input" maxlength="7" />
                                    </div>
                                </div>
                            </div> -->
                            <div role="row">
                                <div role="columnheader" class="align-center">연락처</div>
                                <div role="cell">
                                    <v-row align="center" class="row--x-small">
                                        <v-col>
                                            <input class="input w-100" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <input class="input w-100" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                        </v-col>
                                        <v-col cols="auto">-</v-col>
                                        <v-col>
                                            <input class="input w-100" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                                        </v-col>
                                    </v-row>
                                    <!-- 연락처 폼 -->
                                    <!-- <div class="form-tel">
                                        <input class="input w-100" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                        <span class="text"></span>
                                        <input class="input w-100" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                        <span class="text"></span>
                                        <input class="input w-100" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                                    </div> -->
                                </div>
                            </div>
                            <div role="row">
                                <div role="columnheader" class="align-center">이메일</div>
                                <div role="cell">
                                    <v-row align="center" class="row--small">
                                        <v-col>
                                            <input class="input w-100" type="text" name="email1" v-model="user.email1" />
                                        </v-col>
                                        <v-col cols="auto" class="pa-0">@</v-col>
                                        <v-col>
                                            <input class="input w-100" type="text" name="email2" v-model="user.email2" />
                                        </v-col>
                                        <v-col>
                                            <select v-model="user.email3" class="select w-100" @change="user.email2 = user.email3">
                                                <option :value="null">직접입력</option>
                                                <option :value="`naver.com`">naver.com</option>
                                                <option :value="`daum.net`">daum.net</option>
                                                <option :value="`google.com`">google.com</option>
                                            </select>
                                        </v-col>
                                    </v-row>
                                    <!-- 이메일 폼 -->
                                    <!-- <div class="form-email">
                                        <input class="input w-100" type="text" name="email1" v-model="user.email1" />
                                        <span class="text">@</span>
                                        <input class="input w-100" type="text" name="email2" v-model="user.email2" />
                                        <select v-model="user.email3" class="select" @change="user.email2 = user.email3">
                                            <option :value="null">직접입력</option>
                                            <option :value="`naver.com`">naver.com</option>
                                            <option :value="`daum.net`">daum.net</option>
                                            <option :value="`google.com`">google.com</option>
                                        </select>
                                    </div> -->
                                </div>
                            </div>
                            <!-- <div role="row">
                                <div role="columnheader" class="align-center">주소</div>
                                <div role="cell">
                                    <div class="form-address">
                                        <div class="form-address__postcode">
                                            <input class="input w-100" type="text" v-model="user.postcode" placeholder="우편번호" readonly @click="onSearchPostcode" />
                                            <button class="button button--primary" @click="onSearchPostcode">검색</button>
                                        </div>
                                        <input class="input w-100" type="text" v-model="user.address1" placeholder="기본주소" readonly @click="onSearchPostcode" />
                                        <input class="input w-100" type="text" v-model="user.address2" placeholder="상세주소" />
                                    </div>
                                </div>
                            </div> -->
                        </template>
                        <div role="row" v-if="isSupporter">
                            <div role="columnheader" class="align-center">
                                <span>자문분야</span>
                            </div>
                            <div role="cell">
                                <v-col v-for="parent in areas" :key="parent._id" cols="6" lg="">
                                    <v-row>
                                        <v-col>{{ parent.name }}</v-col>
                                    </v-row>
                                    <v-row v-for="child in parent.children" :key="child._id">
                                        <v-col>
                                            <v-checkbox :label="child.name" v-model="user._areas" :value="child._id" @input="input" hide-details dense class="my-0 py-0" />
                                        </v-col>
                                        <v-col cols="12" v-if="child.name == '기타(입력)' && user._areas.includes(child._id)" class="pt-0">
                                            <v-text-field v-model="user.areas_manual[parent._id]" hide-details dense class="my-0 py-0" outlined />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div v-if="isSupporter" class="join-row join-row--form">
                <div class="join-caption join-caption--center">
                    <h3 class="text-20 text-lg-18">공개정보 <small>(선택입력)</small></h3>
                </div>
                <div role="table" class="join-table">
                    <div role="rowgroup">
                        <form-row title="닉네임">
                            <input class="input w-100" type="text" name="nickname" v-model="user.nickname" @input="input" />
                        </form-row>
                        <form-row title="연락처">
                            <div class="form-tel">
                                <input class="input w-100" type="tel" name="phone1" v-model="user.phone1" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input w-100" type="tel" name="phone2" v-model="user.phone2" @input="input" maxlength="4" />
                                <span class="text"></span>
                                <input class="input w-100" type="tel" name="phone3" v-model="user.phone3" @input="input" maxlength="4" />
                            </div>
                        </form-row>
                        <form-row title="이메일">
                            <div class="form-email">
                                <input class="input w-100" type="text" name="email1" v-model="user.email1" />
                                <span class="text">@</span>
                                <input class="input w-100" type="text" name="email2" v-model="user.email2" />
                                <select v-model="user.email3" class="select" @change="user.email2 = user.email3">
                                    <option :value="null">직접입력</option>
                                    <option :value="`naver.com`">naver.com</option>
                                    <option :value="`daum.net`">daum.net</option>
                                    <option :value="`google.com`">google.com</option>
                                </select>
                            </div>
                        </form-row>
                        <form-row title="전문가 소개">
                            <textarea v-model="user.summary" class=" @input="input" :placeholder="`기업에서 조회하는 전문가 검색 섹션에 표시되는 부분입니다.\n전문분야 및 경력사항을 소개형태로 50자 이상 작성 부탁드립니다.`" />
                        </form-row>
                        <form-row title="전문가 사진">
                            <v-file-input v-model="user.avatar" @input="input" dense hide-details outlined class=" accept="image/*" />
                        </form-row>
                        <form-row title="정보공개동의">
                            <v-switch label="연락처노출" v-model="user.isContactDisplayed" inset class="ma-0 ml-1" />
                        </form-row>
                    </div>
                </div>
            </div>

            <form-description v-if="isSupporter" v-model="user" /> -->
        </div>

        <div class="button-group">
            <v-btn @click="cancel()" large outlined rounded color="grey" elevation="0" class="min-w-120px min-w-lg-200px"><span class="color-grey">취소하기</span></v-btn>
            <v-btn @click="submit()" large rounded color="primary" elevation="0" class="min-w-120px min-w-lg-200px"><span>회원가입</span></v-btn>
        </div>

        <!-- 하단버튼 -->
        <!-- <div class="bottom-button">
            <button class="button button--border-primary" @click="cancel()">
                <span>취소하기</span>
            </button>
            <button class="button button--primary" @click="submit()">
                <span>회원가입</span>
            </button>
        </div> -->

        <daum-postcode ref="daum-postcode" @change="({ postcode, address }) => ((user.postcode = postcode) || true) && ((user.address1 = address) || true)" />
    </div>
</template>

<script>
import dayjs from "dayjs";
import { INDIVIDUAL_KINDS } from "@/assets/variables";

import FormRow from "../form-row.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import FormDescription from "../form-description.vue";

const initialUser = {
    kind: INDIVIDUAL_KINDS.ELSE.value,
    affiliation: null,
    department: null,
    residentNumber: null,
    residentNumber1: null,
    residentNumber2: null,
    postcode: null,
    address1: null,
    address2: null,
    _areas: [],
    areas_manual: {},
    summary: null,
    _avatar: null,
    isContactDisplayed: null,
};

const kinds = [
    { value: INDIVIDUAL_KINDS.ELSE.value, text: "일반인" },
    { value: INDIVIDUAL_KINDS.SUPPORTER.value, text: "전문가" },
];

const regions = ["서울특별시", "부산광역시", "대구광역시", "인천광역시", "광주광역시", "대전광역시", "울산광역시", "세종특별자치시", "경기도", "강원도", "충청북도", "충청남도", "전라북도", "전라남도", "경상북도", "경상남도", "제주특별자치도"];

export default {
    components: {
        FormRow,
        DaumPostcode,
        FormDescription,
    },
    props: ["value", "areas"],
    data() {
        return {
            user: { ...initialUser, ...this.$props.value } || { ...initialUser },

            kinds,
            regions,
        };
    },
    computed: {
        isSupporter() {
            return this.user.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
    },
    watch: {
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },

        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },

        "user.bornAt"() {
            this.$emit("input", this.user);
        },
        "user.residentNumber1"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
        "user.residentNumber2"() {
            if (this.user.residentNumber1?.length == 6) {
                const year = dayjs().format("YY");
                const [yy, mm, dd] = this.user.residentNumber1.match(/.{1,2}/g);

                if (this.user.residentNumber2?.length > 0) {
                    const criterion = this.user.residentNumber2[0];
                    this.user.bornAt = [yy.padStart(4, +criterion < 3 ? "19" : "20"), mm, dd].join("-");
                } else this.user.bornAt = [yy.padStart(4, +yy > +year ? "19" : "20"), mm, dd].join("-");
            } else this.user.bornAt = null;

            this.user.residentNumber = `${this.user.residentNumber1}-${this.user.residentNumber2}`;
        },
    },
    methods: {
        input() {
            this.$emit("input", this.user);
        },
        onSearchPostcode() {
            this.$refs["daum-postcode"].open();
        },
        cancel() {
            this.$router.go(-1);
        },

        submit() {
            if (this.validate()) this.$emit("submit", this.user);
        },

        validate() {
            try {
                if (!this.user.username) throw new Error("아이디를 입력해주세요.");
                if (!this.user.password) throw new Error("비밀번호를 입력해주세요.");
                if (!this.checkPassword(this.user.password)) return false;
                if (!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
                if (this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");
                if (!Object.keys(INDIVIDUAL_KINDS).includes(this.user.kind)) throw new Error("가입유형을 선택해주세요.");
                if (!this.user.name) throw new Error("이름을 입력해주세요.");
                // if (this.isSupporter && !this.user.nickname) throw new Error("닉네임을 입력해주세요.");
                if (!this.user.affiliation) {
                    if (this.user.kind == INDIVIDUAL_KINDS.STUDENT.value) throw new Error("학교/학과를 입력해주세요.");
                    else throw new Error("소속/부서를 입력해주세요.");
                }
                if (!this.isSupporter) {
                    // if (!this.checkResidentNumber()) throw new Error("주민등록번호가 잘못되었습니다.");
                    if (!this.user.phone) throw new Error("휴대전화를 입력해주세요.");
                    if (!this.user.email) throw new Error("이메일을 입력해주세요.");
                    // if (!this.user.postcode || !this.user.address1 || !this.user.address2) throw new Error("주소를 입력해주세요.");
                }

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        checkPassword(password) {
            // var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            // if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");

            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");

            return true;
        },

        checkResidentNumber() {
            const { residentNumber, residentNumber1, residentNumber2 } = this.user;
            if (residentNumber?.length !== 14) return false;

            const [yy, mm, dd] = residentNumber1.match(/.{1,2}/g);
            if (+mm < 1 || +mm > 12) return false;
            if (+dd < 1 || +dd > 31) return false;

            return true;
        },
    },
};
</script>
